import url from '../../../utils/url.js'
import userFriendlyEr from '../../../utils/userFriendlyEr.js'
import permissionMixin from '../../../mixins/permission-mixin.js'
import {PERMS} from '../../../config/permissions.js'
import Sortablejs from 'sortablejs'

const ValueModel = (year) => {
  return {
    year: JSON.parse(JSON.stringify(year)),
    fact: null,
    plan: null
  }
}

const POSITION_IN_HEADER = {
  FIRST: '0',
  SECOND: '1'
}

export default {
  mixins: [permissionMixin],
  data () {
    return {
      searchModel: '',
      data: null,
      rows: null,
      tableHeaders: null,
      checkedRows: null,
      lastYear: 0
    }
  },
  watch: {
    '$route': 'onRouteHandler'
  },
  created () {
    this.init()
  },
  updated () {
    this.attachSortable()
    this.checkEmptyColumn()
  },
  mounted () {
    this.attachSortable()
  },
  computed: {
    measureTypes () {
      return this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()).measure
    },
    items () {
      return this.$store.getters.readUrlEndpoint(this.getEndpoint(this.$route))
    },
    totalRowCount () {
      return Object.keys(this.rows || {}).length
    },
    hasItems () {
      return this.rows && this.tableHeaders && Object.keys(this.rows).length > 0
    }
  },
  methods: {
    checkRow (id) {
      if (this.checkedRows == id) {
        this.checkedRows = null
      }
    },
    scrollHandler ($event) {
      let {scrollLeft = 0} = $event.target
      this.$refs.tableHeader.style.marginLeft = `-${scrollLeft}px`
    },
    onDragEnd (evt) {
      console.log('onDragEnd', evt)
      this.changeOrder(evt)
    },
    changeOrder ({oldIndex, newIndex}) {
      console.log(oldIndex, newIndex)
      if (newIndex === oldIndex) {
        return
      }
      let virtualRows = this.rows
      let realRows = this.$refs.tableBody.getElementsByTagName('tr')
      // get min order value
      let minOrder = 0
      for (let key in virtualRows) {
        if (minOrder === 0 || virtualRows[key][0].order < minOrder) {
          minOrder = virtualRows[key][0].order
        }
      }
      // get changed rows orders
      // diff with virtual and real dom
      let changedRows = []
      let notChangedRows = []
      let i = 0
      for (let v of realRows) {
        let order = (minOrder + i)
        let id = +v.getAttribute('data-id')
        if (virtualRows[i] && virtualRows[i][0] && +virtualRows[i][0].id === +id && +order === +virtualRows[i][0].order) {
          notChangedRows.push(id)
        } else {
          // find row by id
          let data = {}
          for (let key in virtualRows) {
            if (+virtualRows[key][0].id === +id) {
              data = virtualRows[key][0]
              break
            }
          }
          data.id = id
          data.order = order
          changedRows.push(data)
        }
        i++
      }
      this.sortable.option('disabled', true)
      this.$bar.start()
      this.sendOrders(changedRows).then((r) => {
        console.log('data order update', changedRows, r)
        this.$bar.finish()
        this.sortable.option('disabled', false)
        this.setDataFromStore()
        // for update data wihout reorders
        this.rebuildRows(true, notChangedRows)
      }).catch(e => {
        this.$bar.finish()
        this.sortable.option('disabled', false)
      })
      console.log('changedRows', changedRows)
    },
    sendOrders: async function (changedRows = []) {
      for (let i = 0; i < changedRows.length; i++) {
        let v = changedRows[i]
        await this.updateOrder(v, v.order)
      }
      return Promise.resolve(1)
    },
    attachSortable () {
      console.log('---', 'attachSortable')
      this.sortable = null
      if (this.$refs.tableBody) {
        this.sortable = new Sortablejs(this.$refs.tableBody, {
          onEnd: this.onDragEnd
        })
      }
    },
    init () {
      this.setFiltersFromUrl()
      this.setDataFromStore()
      this.rebuildRows()
    },
    setDataFromStore () {
      this.data = Object.assign({}, this.items)
    },
    addNewCol (params) {
      if (!params) {
        return
      }

      this.lastYear++
      // https://redmine.etton.ru/issues/13554
      let addedYear = this.lastYear * 1
      if (addedYear < 1990) {
        addedYear = 1990
      }
      let newCol = new ValueModel(addedYear)
      this.data.data[0].values.push(newCol)
      this.rebuildRows()
      this.createEmptyYearCol(addedYear)
      this.moveTableToLeft()
    },
    moveTableToLeft () {
      if (this.$refs.tablePS) {
        this.$refs.tablePS.setScrollLeft(9999999)
      }
    },
    createEmptyYearCol (year) {
      this.$store.dispatch('createModel', {
        url: this.getEmptyYearCol(year),
        data: {}
      })
    },
    letSearch () {
      let route = url.getRoute(this.$route)
      route.query.q = this.searchModel
      if (!route.query.q) {
        delete route.query.q
      }
      this.$router.push(route)
    },
    onRouteHandler () {
      this.init()
    },
    setFiltersFromUrl () {
      let route = url.getRoute(this.$route)
      this.searchModel = route.query.q || ''
    },
    updateOrder (data = {}, order) {
      return this.$store.dispatch('updateModel', {
        url: this.getUpdateUrl(data.id),
        data: {
          id: data.id,
          order: order,
          name: data.name,
          measure_id: data.measure.id
        }
      }).catch(erResponse => {
        console.error(erResponse)
        this.$e.errorBox(erResponse)
        return erResponse
      }).then(r => {
        // mutate store
        const endpoint = this.getEndpoint(this.$route)
        let storeData = this.$store.getters.readUrlEndpoint(endpoint)
        let foundData = null
        if (storeData && storeData.data) {
          for (let i = 0; i < storeData.data.length; i++) {
            if (storeData.data[i] && +storeData.data[i].id === +data.id) {
              storeData.data[i].order = order
              foundData = storeData.data[i]
              break
            }
          }
        }
        console.log('storeData', JSON.stringify(foundData))
        return r
      })
    },
    rebuildRows (skipRecalcOrder = false, skipedRows = []) {
      console.log('rebuildRows')
      let rows = {}
      this.lastYear = 0
      let data = this.data.data
      console.log(data)
      if (skipRecalcOrder === false) {
        // sort by order, id
        data.sort((a, b) => {
          if (a.order > b.order) {
            return 1
          }
          if (a.order < b.order) {
            return -1
          }
          if (a.order === b.order) {
            if (a.id > b.id) {
              return 1
            }
            if (a.id < b.id) {
              return -1
            }
          }
          return 0
        })
        // update order
        let minOrder = 0
        data.forEach((currentVal, i) => {
          if (minOrder === 0 || data[i].order < minOrder) {
            minOrder = +data[i].order
          }
        })
        data.forEach((currentVal, i) => {
          const newOrder = minOrder + i
          if (data[i].order !== newOrder) {
            data[i].order = newOrder
            // if wrong save on server
            // this.updateOrder(data[i], newOrder)
          }
        })
      }
      // TODO: use skipedRows if perfomance problem
      // add missed values
      data.forEach((currentVal, i) => {
        data.forEach(comparedVal => {
          let missedValues = []
          comparedVal.values.forEach(v => {
            let yearExist = currentVal.values.findIndex(s => s.year === v.year)
            if (yearExist === -1) {
              missedValues.push(new ValueModel(v.year))
            }
          })
          // put to current
          missedValues.forEach(v => {
            data[i].values.push(v)
          })
        })
      })
      console.log('add number/doc, measure')
      data.forEach((v, index) => {
        // add number/doc, measure
        let id = index // this.getId(v, index)
        rows[id] = [
          {
            title: 'Номер', value: v.order, _headers: [
              {
                name: POSITION_IN_HEADER.FIRST,
                rowspan: 2,
                colspan: false
              }
            ],
            width: 130,
            id: v.id,
            order: +v.order,
            name: v.name,
            measure: v.measure
          },
          {
            title: 'Наименование', value: v.name, _headers: [
              {
                name: POSITION_IN_HEADER.FIRST,
                rowspan: 2,
                colspan: false
              }
            ],
            width: 380
          },
          {
            title: 'Документ', value: v.document, _headers: [
              {
                name: POSITION_IN_HEADER.FIRST,
                rowspan: 2,
                colspan: false
              }
            ],
            width: 100
          },
          {
            title: 'Единица измерения', value: v.measure.name, _headers: [
              {
                name: POSITION_IN_HEADER.FIRST,
                rowspan: 2,
                colspan: false
              }
            ],
            width: 100
          }
        ]
        // sort years
        v.values.sort((b, a) => {
          if (a.year > b.year) {
            return -1
          } else if (a.year < b.year) {
            return 1
          } else {
            return 0
          }
        })

        const planWidth = 80
        const factWidth = 80
        v.values.forEach(value => {
          if (value.year && value.year > this.lastYear) {
            this.lastYear = +value.year
          }
          if (value.fact !== null) {
            value.fact = +value.fact
          }
          if (value.plan !== null) {
            value.plan = +value.plan
          }
          rows[id].push({
            _headers: [{
              name: POSITION_IN_HEADER.FIRST,
              rowspan: false,
              colspan: 2,
              title: +value.year,
              year: +value.year,
              width: (planWidth + factWidth)
            }, {
              name: POSITION_IN_HEADER.SECOND,
              rowspan: false,
              colspan: false,
              title: 'План',
              width: planWidth
            }
            ],
            title: 'План',
            value: value.plan,
            _isPlan: true,
            year: value.year,
            id: v.id,
            _isEdit: false,
            _error: '',
            width: planWidth
          })
          rows[id].push({
            _headers: [{
              name: POSITION_IN_HEADER.SECOND,
              rowspan: false,
              colspan: false,
              title: 'Факт',
              width: factWidth
            }],
            title: 'Факт',
            value: value.fact,
            _isFact: true,
            year: value.year,
            id: v.id,
            _isEdit: false,
            _error: '',
            width: factWidth
          })
        })
      })

      // generate headers by first row
      let tableHeaders = {}
      for (let key in rows) {
        rows[key].forEach(v => {
          v._headers.forEach(headerItem => {
            if (!tableHeaders[headerItem.name]) {
              tableHeaders[headerItem.name] = []
            }
            tableHeaders[headerItem.name].push({
              colspan: headerItem.colspan,
              rowspan: headerItem.rowspan,
              value: headerItem.title || v.title,
              year: headerItem.year || 0,
              width: headerItem.width,
              columnEmpty: false
            })
          })
        })
        break
      }

      this.rows = Object.assign({}, rows)
      this.tableHeaders = Object.assign({}, tableHeaders)
      this.checkEmptyColumn()
      console.log('rebuildRows', this.rows, this.tableHeaders)
    },
    checkEmptyColumn () {
      console.log('checkEmptyColumn')
      let notEmptyYears = []
      // check all value and collect not empty
      for (let rowKey in this.rows) {
        let row = this.rows[rowKey]
        row.forEach(col => {
          if (col.value !== null) {
            notEmptyYears.push(col.year)
          }
        })
      }
      // check headers and set empty
      let headerRow = this.tableHeaders[POSITION_IN_HEADER.FIRST] || []
      headerRow.forEach((headerCol, headerIndex) => {
        if (headerCol.year) {
          if (notEmptyYears.indexOf(headerCol.year) > -1) {
            this.tableHeaders[POSITION_IN_HEADER.FIRST][headerIndex].columnEmpty = false
          } else {
            this.tableHeaders[POSITION_IN_HEADER.FIRST][headerIndex].columnEmpty = true
          }
        }
      })
    },
    updateScroll (delayed = false) {
      if (delayed === true) {
        setTimeout(() => {
          this.updateScroll()
        }, 0)
        return
      }
      if (this.$refs.tablePS) {
        this.$refs.tablePS.update()
      }
    },
    deleteEmptyColumn (year) {
      this.$e.confirmBox(
        'Колонка будет удалена, если в ней не были заданы значения',
        'Удалить колонку?'
      ).then(() => {
        this.$bar.start()
        this.$store.dispatch('deleteModel', {
          url: this.getDeleteEmptyColumnUrl(year),
          data: {},
          endpoint: this.getEndpoint(this.$route)
        }).then(r => {
          this.$e.successBox('Запись удалена')
          this.fetchData()
        }).catch(erResponse => {
          this.$bar.finish()
          console.error(erResponse)
          this.$e.errorBox(erResponse)
        })
      })
    },
    setEdit (item, colIndex) {
      if (colIndex < 4) {
        return
      }
      if (this.userHavePermissionEx(PERMS.EDIT) === true) {
        item._isEdit = true
      }
    },
    saveEdit (item) {
      if (item.value) {
        item.value = item.value.toString().replace(/,/, '.')
        item.value = item.value.toString().replace(/,/g, '')
      }
      let doublePattern = /^(\d*((\.\d{0,2}))?(\d))$/i
      if (!doublePattern.test(item.value)) {
        item._error = 'Введите число'
        return false
      }
      item._isEdit = false

      if (item._isPlan) {
        item.plan = +item.value
      } else {
        item.fact = +item.value
      }

      this.$store.dispatch('updateModel', {
        url: this.getObjectPlanFactUpdateUrl(item.id, item.year),
        endpoint: null,
        data: item
      }).then(r => {
        if (r.id) {
          item.id = r.id
        }
      }).catch(e => {
        item._isEdit = true
        item._error = userFriendlyEr.recognize(e)
      })
    },
    getId (item) {
      return item.id
    },
    fetchData () {
      const {asyncData} = this.$options
      this.$bar.start()
      asyncData({
        store: this.$store,
        route: this.$route,
        methods: this
      }).then(() => {
        this.init()
        this.$bar.finish()
        this.updateScroll(true)
      }).catch(() => {
        this.$bar.finish()
      })
    },
    deleteItem (item) {
      this.$e.confirmBox(
        'Удаленную запись нельзя будет восстановить',
        'Удалить запись?'
      ).then(() => {
        this.$store.dispatch('deleteModel', {
          url: this.getDeleteUrl(item.id),
          data: {id: item.id},
          endpoint: this.getEndpoint(this.$route)
        }).then(r => {
          // fix: https://redmine.etton.ru/issues/13316
          this.checkedRows = null
          this.$e.successBox('Запись удалена')
          this.fetchData()
        }).catch(erResponse => {
          console.error(erResponse)
          this.$e.errorBox(erResponse)
        })
      })
    },
    onDeleteItem () {
      if (!this.checkedRows) {
        return
      }
      this.deleteItem({id: this.checkedRows})
    },
    onCreateItem () {
      this.redirectToForm(null)
    },
    onEditItem () {
      if (!this.checkedRows) {
        return
      }
      this.redirectToForm(this.checkedRows)
    },
    redirectToForm (id) {
      let prevRoute = url.getRoute(this.$route, true)
      this.$router.push({
        name: this.$route.name + (id ? '.update' : '.create'),
        params: {id: id},
        query: {
          prevRoute: prevRoute
        }
      })
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getEndpoint(route, fromRoute)}))
    }

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
